import { render } from "./InsertStudent.vue?vue&type=template&id=b20d1196&scoped=true"
import script from "./InsertStudent.vue?vue&type=script&lang=js"
export * from "./InsertStudent.vue?vue&type=script&lang=js"

import "./InsertStudent.vue?vue&type=style&index=0&id=b20d1196&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b20d1196"]])

export default __exports__